import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourDashboardApi from '@/features/dashboard/tours/api/tourDashboardApi.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { TourDashboardSummaryDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardSummaryDto.ts';

const useGetTourDashboardSummary = (tourId: string) =>
  useQuery(getTourDashboardSummaryQueryOptions(tourId));

export const getTourDashboardSummaryQueryOptions = (
  tourId: string,
): UseQueryOptions<TourDashboardSummaryDto> => ({
  queryKey: tourDashboardApiQueryKeys.summary(tourId),
  queryFn: () => tourDashboardApi.getSummary(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourDashboardSummary;
